if (!customElements.get('product-card-updated')) {
  customElements.define('product-card-updated', class ProductCardUpdated extends HTMLElement {
    constructor() {
      super();
      this.currentVariantId = null;
      this.colorClicked = false;
      this.swatchesExpanded = false;
      
      this.init();
    }

    init() {
      this.setupSwatchHandlers();
      this.setupExpandSwatches();
      this.handleSalePagePricing();
    }

    setupSwatchHandlers() {
      const swatches = this.querySelectorAll('.ns-product__swatch-input');
      
      swatches.forEach(swatch => {
        swatch.addEventListener('change', (e) => {
          if (e.target.checked) {
            this.handleSwatchChange(e.target);
          }
        });
      });
    }

    handleSwatchChange(swatch) {
      const variantId = swatch.dataset.variantId;
      const colorName = swatch.dataset.colorName;
      const imageUrl = swatch.dataset.imageUrl;
      const imageSrcset = swatch.dataset.imageSrcset;
      const altImageUrl = swatch.dataset.altImageUrl;
      const altImageSrcset = swatch.dataset.altImageSrcset;
      const price = swatch.dataset.price;
      const comparePrice = swatch.dataset.comparePrice;
      this.currentVariantId = variantId;
      this.colorClicked = true;

      this.updateImages(imageUrl, imageSrcset, altImageUrl, altImageSrcset);
      this.updatePricing(price, comparePrice);
      this.updateColorName(colorName);
      this.updateProductLink(variantId);
      this.updateWishlistButton(variantId);
    }

    updateImages(imageUrl, imageSrcset, altImageUrl, altImageSrcset) {
      const mainImage = this.querySelector('[data-main-image]');
      const altImage = this.querySelector('[data-alt-image]');
      
      // Update main image
      if (mainImage && imageUrl) {
        mainImage.src = imageUrl;
        if (imageSrcset) {
          mainImage.srcset = imageSrcset;
        }
        console.log('✅ Main image updated');
      }

      // Update alt image
      if (altImage && altImageUrl) {
        altImage.src = altImageUrl;
        if (altImageSrcset) {
          altImage.srcset = altImageSrcset;
        }
        altImage.style.display = '';
      } else if (altImage) {
        altImage.style.display = 'none';
      } else {
      }
    }

    updateColorName(colorName) {
      const colorNameElement = this.querySelector('[data-current-color-name]');
      if (colorNameElement) {
        colorNameElement.textContent = colorName;
      }
    }

    updatePricing(price, comparePrice) {
      const priceContainer = this.querySelector('.ns-product__price-container');
      const priceRange = this.querySelector('[data-price-range]');
      
      if (!priceContainer) return;

      if (priceRange) {
        priceRange.style.display = 'none';
      }

      priceContainer.innerHTML = '';

      if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
        const comparePriceElement = document.createElement('span');
        comparePriceElement.className = 'ns-product__compare-price';
        comparePriceElement.textContent = comparePrice;
        priceContainer.appendChild(comparePriceElement);
      }

      const priceElement = document.createElement('span');
      priceElement.className = 'ns-product__price';
      priceElement.setAttribute('data-current-price', '');
      priceElement.textContent = price;
      priceContainer.appendChild(priceElement);
    }

    updateProductLink(variantId) {
      const allLinks = this.querySelectorAll('a');
      
      allLinks.forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variantId);
        link.href = url.toString();
      });
    }

    updateWishlistButton(variantId) {
      const wishlistButton = this.querySelector('.swym-button');
      if (wishlistButton) {
        wishlistButton.setAttribute('data-variant-id', variantId);
      }
    }

    setupExpandSwatches() {
      const expandButton = this.querySelector('[data-expand-swatches]');
      if (!expandButton) return;

      expandButton.addEventListener('click', () => {
        if (this.swatchesExpanded) return;
        
        const hiddenSwatches = this.querySelectorAll('[data-hidden-swatch]');
        hiddenSwatches.forEach(element => {
          element.style.display = element.tagName === 'INPUT' ? 'block' : 'flex';
        });
        
        expandButton.style.display = 'none';
        this.swatchesExpanded = true;
        
        // Re-setup event handlers for newly visible swatches
        this.setupSwatchHandlers();
      });
    }

    handleSalePagePricing() {
      if (window.location.pathname === '/collections/sale') {
        const priceRangeElements = this.querySelectorAll('.priceRangePrice');
        priceRangeElements.forEach(element => {
          element.style.color = '#c93933';
        });
      }
    }
  })
}
